const reviews = [
  {
    name: "初雪不吃冰",
    role: "雪景漫画爱好者",
    text: "终于找到专门做雪景漫画的地方了！《雾凇镇物语》看得我又哭又笑，画风清透，冬天看特别有氛围。分类很细，点开就能读，省了我到处找资源的功夫。",
  },
  {
    name: "北纬六十六度",
    role: "冬物语收藏家",
    text: "追《雪月花》追了三个月，更新很稳定，高清图也舒服。首页编辑精选口味很对我，冷门佳作一找一个准，是真正的冬日漫画迷才知道的宝藏站。",
  },
  {
    name: "围炉夜话人",
    role: "每日通勤阅读",
    text: "下班路上点开《暖炉与月光》，一天的疲惫都散了。页面暗色调不刺眼，晚上看很舒服。推荐给身边好几个朋友，都入坑了。",
  },
  {
    name: "积雪尚浅",
    role: "雪女题材同好",
    text: "雪女漫画这么冷门的题材都单独分类，真的太懂我了。《雪女的长夜》画得太美了，雪夜里看，氛围感直接拉满，追更不迷路是真的。",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-9 text-center">
          <p className="inline-flex items-center gap-2 text-sm text-primary-500">
            <i className="ri-chat-3-line"></i> 读者口碑
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            被雪记住的每一个读者
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {reviews.map((r) => (
            <figure
              key={r.name}
              className="flex flex-col rounded-lg border border-background-200/60 bg-background-100 p-6"
            >
              <div className="flex items-center gap-1 text-primary-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/60 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100/80 text-sm font-semibold text-primary-700">
                  {r.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{r.name}</p>
                  <p className="text-xs text-foreground-500">{r.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}